export enum systemTaskColor {
    outdated = '#DF989C',
    in_progress = '#1094F7',
    today = '#A6D46C',
    seven_days = '#ADA6DE',
}
